import React, { useEffect, useState } from "react";
import OfflineConfigSearch from "./OfflineConfigSearch";
import OfflineConfigData from "./OfflineConfigData";

export default function OfflineConfig() {
	const [searchQuery, setSearchQuery] = useState(null);
	useEffect(() => {
		return () => {
			setSearchQuery(null);
		};
	}, []);

	return (
		<div className="offline-config-layout">
			<OfflineConfigSearch
				setSearchQuery={setSearchQuery}
				searchQuery={searchQuery}
			/>
			<OfflineConfigData searchQuery={searchQuery} />
		</div>
	);
}
